
import { useState, useEffect } from 'react';

/**
 * A hook that delays updating a value until after a specified delay
 * Used to prevent excessive function calls (like API requests) during rapid changes
 */
export function useDebounce<T>(value: T, delay: number = 300): T {
  const [debouncedValue, setDebouncedValue] = useState<T>(value);

  useEffect(() => {
    // Set a timeout to update the debounced value after the delay
    const timer = setTimeout(() => setDebouncedValue(value), delay);

    // Clear the timeout if the value changes before the delay expires
    return () => clearTimeout(timer);
  }, [value, delay]);

  return debouncedValue;
}
